/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedR7aUrceniEditoraZpsCreateUpdateRequest } from '../types/PatchedR7aUrceniEditoraZpsCreateUpdate';
import type { R7aUrceniEditoraZpsCreateUpdateResponse } from '../types/R7aUrceniEditoraZpsCreateUpdate';

export type R7UrceniEditoraZpsPartialUpdateRequest = PatchedR7aUrceniEditoraZpsCreateUpdateRequest;
export type R7UrceniEditoraZpsPartialUpdateResponse = R7aUrceniEditoraZpsCreateUpdateResponse;

export type R7UrceniEditoraZpsPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this urceny editor zps.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/r7_urceni_editora_zps/{id}/
 *
 * ```yaml
 * operationId: r7_urceni_editora_zps_partial_update
 * tags:
 *   - r7_urceni_editora_zps
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedR7aUrceniEditoraZpsCreateUpdate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedR7aUrceniEditoraZpsCreateUpdate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedR7aUrceniEditoraZpsCreateUpdate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/R7aUrceniEditoraZpsCreateUpdate'
 *     description: ''
 * ```
 */
export const r7UrceniEditoraZpsPartialUpdateOperation = ({
  id,
  ...rest
}: R7UrceniEditoraZpsPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/r7_urceni_editora_zps/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/r7_urceni_editora_zps/{id}/' };
  };

/**
 * PATCH /dmx-server/r7_urceni_editora_zps/{id}/
 *
 * ```yaml
 * operationId: r7_urceni_editora_zps_partial_update
 * tags:
 *   - r7_urceni_editora_zps
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedR7aUrceniEditoraZpsCreateUpdate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedR7aUrceniEditoraZpsCreateUpdate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedR7aUrceniEditoraZpsCreateUpdate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/R7aUrceniEditoraZpsCreateUpdate'
 *     description: ''
 * ```
 */
export const r7UrceniEditoraZpsPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: R7UrceniEditoraZpsPartialUpdateQuery;
  request: PatchedR7aUrceniEditoraZpsCreateUpdateRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<R7aUrceniEditoraZpsCreateUpdateResponse>> => {
  const operation = r7UrceniEditoraZpsPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
